import React from "react";
import {observer} from "mobx-react-lite";
import {useTranslation} from "react-i18next";
import "./eventStartAndEndView.sass";
import ButtonIcon from "../../atoms/button/buttonIcon";
import {EventStatus} from "../../../shared/enums/eventStatus";
import ViewField from "../../molecules/viewField/viewField";
import {
  ICanCancelOrPostponeProps,
  IEventDetailsProps
} from "../../../shared/interfaces/sharedProps";
import {useStores} from "../../../stores/useStores";
import EventTimeAndDateFormat from "../../atoms/eventTimeAndDateFormat/eventTimeAndDateFormat";
import EventSeriesTimeAndDateFormat from "../../atoms/eventSeriesTimeAndDateFormat/eventSeriesTimeAndDateFormat";

export interface IEventStartAndEndViewProps
  extends IEventDetailsProps,
    ICanCancelOrPostponeProps {
  isCancellingPostponing: boolean;
  isDisabled?: boolean;
  isEditingSingleOccurrence?: boolean;
  isEndTimeVisible?: boolean;
}

const EventStartAndEndView: React.FC<IEventStartAndEndViewProps> = ({
  eventDetails,
  isCancellingPostponing,
  isDisabled,
  openCancelPostponeModalAction,
  shouldShowCancelOrPostponeButton,
  isEditingSingleOccurrence,
  isEndTimeVisible
}) => {
  const {t} = useTranslation(["event"]);
  const {
    uiStore: {eventsUiStore}
  } = useStores();

  return (
    <ViewField label={t("event:labels.dateAndTime")}>
      {eventDetails.isRecurringEvent && !isEditingSingleOccurrence ? (
        <EventSeriesTimeAndDateFormat
          eventRecurrenceDetails={eventDetails.eventRecurrenceDetails!}
          timeAndDate={eventDetails.eventDateDetails.startDate.date!}
          endTime={eventDetails.eventDateDetails.endDate.date!}
          recurrenceEndDate={
            eventDetails.eventRecurrenceDetails?.recurrenceEndDate?.date
          }
          timeZone={eventDetails.eventDateDetails.timeZone}
          isEnhanced={eventsUiStore.isEnhancedCalendar}
        />
      ) : (
        <EventTimeAndDateFormat
          timeAndDate={eventDetails.eventDateDetails.startDate.date!}
          endTime={eventDetails.eventDateDetails.endDate.date!}
          timeZone={eventDetails.eventDateDetails.timeZone}
          isEndTimeVisible={isEndTimeVisible}
        />
      )}
      {
        // Postpone button
        shouldShowCancelOrPostponeButton && (
          <div className="startAndEnd postpone-button">
            <ButtonIcon
              type="secondary-negative"
              onClick={() =>
                openCancelPostponeModalAction(EventStatus.Postponed)
              }
              isDisabled={isDisabled || isCancellingPostponing}
              isBusy={
                isCancellingPostponing || eventsUiStore.isLoadingEventBookings
              } // wait for fully loaded bookings in order to display the correct numbers
            >
              {t("event:actions.postpone")}
            </ButtonIcon>
          </div>
        )
      }
    </ViewField>
  );
};

export default observer(EventStartAndEndView);
